(ns admin.events.bootstrap
  (:require [akiroz.re-frame.storage :refer [persist-db]]
            [kyber.events.utils :refer [kyber-event-fx
                                        kyber-event-db]]
            [kyber.constants :as c]
            [admin.db.core :refer [default-db]]))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Start
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defn- on-session-success-hook
  [_]
  ;; no-op
  )

(defn start
  [_ _]
  {:analytics/start-polling                 true
   :analytics/track-page-blur               true
   :db                                      default-db
   :extend-cljs                             nil
   :dev-tools-init                          nil
   :add-polyfils                            true
   :pushy-init                              nil
   :aws-config                              nil
   :authentication/set-auth-redirect        true
   :bootstrap/init-logrocket                nil

   ;; When there is cross domain config we want admin analytics turned off
   ;; [[9474]]
   ;; cross domain config should only be used to funnel google analytics to PRI (partner)
   ;; they should only see learner app analytics
   :bootstrap/init-google-analytics         (not (-> c/google-tracking-cross-domains first not-empty some?))

   :bootstrap/print-app-version-information true
   :bootstrap/setup-dev-hotkeys             nil
   :bootstrap/spec-chec-polling             false
   :ui/set-fullscreen-listeners             nil
   ;; Note: Order is important here
   :dispatch-n                              [[:bootstrap/init-bugsnag]
                                             [:authentication/configure-cognito
                                              {:session-options {:on-session-success
                                                                 on-session-success-hook}}]
                                             [:bootstrap/hydrate-from-local-storage]
                                             [:bootstrap/send-session-information]]})

(kyber-event-fx :bootstrap/start start)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Hydrate Local State
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defn hydrate-from-local-storage
  [{:keys [session] :as db} _]
  (cond-> db
    (nil? session) (assoc :session (:session default-db))))

(kyber-event-db :bootstrap/hydrate-from-local-storage
                [(persist-db :session :session)]
                hydrate-from-local-storage)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Send session information
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defn- flatten-ua-property
  [namespace-key property-map]
  (reduce (fn [flattened-map [ua-prop ua-val]]
            (assoc flattened-map
                   (-> namespace-key
                       name
                       (str "-" (name ua-prop))
                       keyword)
                   ua-val))
          {}
          property-map))

(defn- get-ua-stats
  []
  (let [ua-stats (-> (js/window.UAParser.)
                     (.getResult)
                     (js->clj :keywordize-keys :true))]
    (reduce (fn [ua [ua-key ua-val]]
              (if (map? ua-val)
                (merge ua (flatten-ua-property ua-key ua-val))
                (assoc ua ua-key ua-val)))
            {}
            ua-stats)))

(when ^boolean js/goog.DEBUG
  (def event-doc-send-session-information
    {:description
     "Initial session event sent during the bootstrapping process"
     :data-warehouse true
     :changelog
     [{:date "13MAY18"
       :event-version 0
       :data {:browser-major :string
              :browser-name :string
              :cpu-architecture {:type :string :optional true}
              :device-model {:type :string :optional true}
              :device-type {:type :string :optional true}
              :device-vendor {:type :string :optional true}
              :engine-name :string
              :engine-version :string
              :os-name :string
              :os-version :string
              :ua :string}}]}))

(defn send-session-information
  [{:keys [db]} [event-name _]]
  {:db db
   :dispatch [:analytics/save-datapoint
              (merge {:event event-name
                      :event-version 0}
                     (get-ua-stats))]})

(kyber-event-fx :bootstrap/send-session-information
                send-session-information)
